export const version = "abi/5.1.0";
//# sourceMappingURL=_version.js.map